import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class Tooltip extends Component {
  constructor() {
    super();
    this.state = {
      show: false
    }
    // this.handleMouseIn = this.handleMouseIn.bind(this);
    this.handleMouseOut = this.handleMouseOut.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }
  
  handleMouseIn() {
    this.setState({ show: true });
  }
  
  handleMouseOut() {
    this.setState({ show: false });
  }
  
  handleClick() {
    this.setState({ show: !this.state.show });
  }
  
  render() {
    return (
      <div className='tooltipCustom'
        onClick={this.props.trigger === 'click' ? this.handleClick : false}
        onMouseLeave={this.props.trigger === 'click' ? this.handleMouseOut : false}
      >
        {this.state.show &&
            <div className={`tooltipCustom-content ${this.props.position}`}>
              {this.props.content}
            </div>
        }
        {this.props.children}
      </div>
    );
  }
}
  
Tooltip.propTypes = {
  content: PropTypes.string.isRequired,
  position: PropTypes.string,
  trigger: PropTypes.string
};
  
Tooltip.defaultProps = {
  position: 'top',
  trigger: 'hover'
};


// WEBPACK FOOTER //
// ./src/views/controls/Tooltip.js